import { render, staticRenderFns } from "./EstoqueSolicitacoesRealizadas.vue?vue&type=template&id=921c6480&scoped=true&"
import script from "./EstoqueSolicitacoesRealizadas.vue?vue&type=script&lang=js&"
export * from "./EstoqueSolicitacoesRealizadas.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueSolicitacoesRealizadas.vue?vue&type=style&index=0&id=921c6480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921c6480",
  null
  
)

export default component.exports